import CompareIcon from '@jetbrains/icons/compare.svg'
import {Col, Row} from '@jetbrains/ring-ui/components/grid/grid'
import classNames from 'classnames'

import EntityLink from '../../../../../containers/EntityLink'
import {getCompareBuildHref, getOverviewHref} from '../../../../../routes'
import {stringifyId} from '../../../../../types'
import type {BuildId, BuildTypeId} from '../../../../../types'
import BuildNumber from '../../../../common/BuildNumber/BuildNumber'
import Link from '../../../../common/Link/Link'
import MiddleEllipsis from '../../../../common/MiddleEllipsis/MiddleEllipsis'
import SvgIcon from '../../../../common/SvgIcon/SvgIcon'

import styles from './DependencyRow.css'

type Props = {
  buildTypeId: BuildTypeId | null | undefined
  buildTypeName: string | null | undefined
  buildId1: BuildId | null | undefined
  buildNumber1?: string | null | undefined
  isCanceled1: boolean
  isPersonal1: boolean
  state1: string
  buildId2: BuildId | null | undefined
  buildNumber2?: string | null | undefined
  isCanceled2: boolean
  isPersonal2: boolean
  state2: string
  changed?: boolean | null | undefined
}

function DependencyRow({
  buildTypeId,
  buildTypeName,
  buildId1,
  buildNumber1,
  isCanceled1,
  isPersonal1,
  state1,
  buildId2,
  buildNumber2,
  isCanceled2,
  isPersonal2,
  state2,
  changed,
}: Props) {
  return (
    <Row
      className={classNames(styles.row, {
        [styles.changed]: changed,
      })}
    >
      <Col className={styles.nameCol}>
        {buildTypeName != null ? (
          <EntityLink title={buildTypeName} buildTypeId={buildTypeId} className={styles.caption}>
            <MiddleEllipsis tailLength={3} className={styles.nameCol}>
              {buildTypeName}
            </MiddleEllipsis>
          </EntityLink>
        ) : null}
      </Col>
      <Col className={styles.buildNumberCol}>
        {buildId1 != null && buildNumber1 != null ? (
          <BuildNumber
            buildId={buildId1}
            number={buildNumber1}
            isCanceled={isCanceled1}
            isPersonal={isPersonal1}
            isQueued={state1 === 'queued'}
            href={getOverviewHref({
              buildId: buildId1,
              buildTypeId,
            })}
            hideStar
            className={styles.buildNumber}
            isMine={false}
            withComment={false}
            withStatusChangeComment={false}
            withWarnings={false}
          />
        ) : (
          ' '
        )}
      </Col>
      <Col className={styles.buildNumberCol}>
        {buildId2 != null && buildNumber2 != null ? (
          <BuildNumber
            buildId={buildId2}
            number={buildNumber2}
            isCanceled={isCanceled2}
            isPersonal={isPersonal2}
            isQueued={state2 === 'queued'}
            href={getOverviewHref({
              buildId: buildId2,
              buildTypeId,
            })}
            className={styles.buildNumber}
            isMine={false}
            withComment={false}
            withStatusChangeComment={false}
            withWarnings={false}
          />
        ) : (
          ' '
        )}
      </Col>
      <Col className={styles.buildComparerCol}>
        {buildId1 != null && buildId2 != null && buildId1 !== buildId2 ? (
          <Link href={`${getCompareBuildHref(buildId1)}?withBuildId=${stringifyId(buildId2)}`}>
            <SvgIcon icon={CompareIcon} title="Compare builds" />
          </Link>
        ) : (
          ' '
        )}
      </Col>
    </Row>
  )
}

export default DependencyRow
